import { render } from "./GameEndPopup.vue?vue&type=template&id=1f322c5a&scoped=true"
import script from "./GameEndPopup.vue?vue&type=script&lang=js"
export * from "./GameEndPopup.vue?vue&type=script&lang=js"

import "./GameEndPopup.vue?vue&type=style&index=0&id=1f322c5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f322c5a"]])

export default __exports__